export default __webpack_public_path__ + "static/small-6-4f420282daf2b35c25d4f92331384719.png";